import React from 'react';
const ModalLayout = ({ children, sideBar, title }) => {
  return (
    <div className="w-full h-full p-2 flex">
      <div className="w-[176px] flex-shrink-0 bg-white rounded-lg overflow-hidden">
        <div
          style={{ background: 'linear-gradient(94deg, #D9F0FF 0%, #FFF 100%)' }}
          className="w-full h-[50px] flex items-center"
        >
          <span className="text-[#2d2d2d] text-sm font-medium ml-[14px] translate-y-[-4px]">{title}</span>
        </div>
        <div
          onMouseDown={(e) => e.stopPropagation()}
          className="w-full cursor-default rounded bg-white translate-y-[-8px]"
          style={{ height: 'calc(100% - 40px)' }}
        >
          {sideBar}
        </div>
      </div>
      <div className="flex-1 rounded-lg ml-2 overflow-hidden" onMouseDown={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};
export default ModalLayout;
